<template lang="pug">
.alert(:class="type" role="alert")
  .alert__icon
    i.uil.uil-exclamation-triangle(aria-hidden="true")
  .alert__title {{ title }}
  .alert__subtitle {{ subtitle }}
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    type: String,
  },
};
</script>

<style lang="scss" scoped>
.alert {
  @apply flex;
  @apply flex-col;
  @apply items-center;
  @apply px-4;
  @apply py-5;
  @apply rounded-lg;
  @apply text-center;
  @apply bg-yellow-50;
  @apply text-yellow-700;
  @apply border;
  @apply border-yellow-200;

  &__icon {
    @apply flex;
    @apply items-center;
    @apply justify-center;
    @apply h-12;
    @apply w-12;
    @apply mb-3;
    @apply rounded-full;
    @apply bg-yellow-100;

    i {
      @apply text-2xl;
      @apply leading-none;
      @apply text-yellow-600;
    }
  }

  &__title {
    @apply text-base;
    @apply font-semibold;
    @apply leading-snug;
  }

  &__subtitle {
    @apply text-sm;
    @apply leading-relaxed;
    @apply mt-1;
    @apply opacity-90;
  }
}

.info {
  @apply bg-gignetblue-100;
  @apply text-gignetblue-600;
  @apply border-gignetblue-200;

  .alert__icon {
    @apply bg-gignetblue-200;
    i {
      @apply text-gignetblue-600;
    }
  }
}
</style>
